module.exports = __webpack_public_path__ + "static/img/feature-bg13.b8c537a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/feature-bg13.png
// module id = 9DU/
// module chunks = 0